export { default as TempSelectedLifestyle } from './TempSelectedLifestyle';
